<button class="group-button group-button-focus" (click)="openSideSheet.emit('bundle-summary')">
  Preisübersicht
</button>

<button class="group-button group-button-primary" [disabled]="addToCartDisabled() || isAddToCartLoading()" (click)="addToCart.emit()">
  @if (isAddToCartLoading()) {
    <ui-icon [faName]="'spinner-third'" [faStyle]="'light'" animation="spin"></ui-icon>
  }
  In den Warenkorb
</button>

<button class="group-button group-button-focus" (click)="openSideSheet.emit('slot-step-summary')">
  Paketübersicht
</button>
